<template>
    <div
        class="gap-sm pb-lg bg-lightest -mx-xs p-sm lg:bg-initial col-span-12 flex flex-col rounded-t-md lg:mx-0 lg:rounded-none lg:p-0"
    >
        <div class="flex items-center justify-between">
            <div class="gap-xs flex flex-col">
                <h1>Support</h1>
                <p class="text-md">Submit any and all requests that fit your needs</p>
            </div>
            <Button v-if="showCreateRequest" class="hidden lg:flex!" @click="createUrl">
                <span>
                    <p>Create new request</p>
                </span>
                <i class="i-request" />
            </Button>
        </div>
        <RequestOverview
            :show-filters="true"
            :show-create-request="showCreateRequest"
            :compact-mobile-cards="true"
            :show-display-toggle="true"
        />
    </div>
</template>

<script setup lang="ts">
import { Button } from '@/components/ui/button';
import { computed } from 'vue';
import router from '@/router';
import RequestOverview from '@/components/support/request-overview.vue';
import { useOrganizationStore } from '@/stores/organization';

const usersOrganization = computed(() => useOrganizationStore().usersOrganization);
const user = computed(() => useOrganizationStore().user);
const showCreateRequest = computed(() =>
    user.value?.organizations
        ?.find((org) => org.organization_id === usersOrganization.value?.organization_id)
        ?.organization_roles.some((role) => role.name === 'org-admin' || role.name === 'user-ticket-creator'),
);

function createUrl() {
    // TODO: write logic here that creates a different create url based on available data for the current user

    // 1 SD skips serviceDesk selection page
    // 1 RTG skips requestTypeGroup selection page
    router.push('/support/servicedesks');
}
</script>
